import * as React from 'react';

import { ERequestDemandField, EUserType } from '../../../../constants/requestDemand';
import { FormFieldInput } from '@cian/ui-kit/form';
import { fromEventToFormField, fromFormFieldToValues, getFormErrors, getFormInitialState } from '../../utils';
import { SubmitButton } from '../SubmitButton';
import { SelectUserType } from '../SelectUserType';
import * as styles from './RequestDemandForm.css';
import { TRequestValues } from '../../../../types/requestDemand';
import { RequestDemandAgreements } from '../RequestDemandAgreements';

interface IRequestDemandFormProps extends TRequestValues {
  onSubmit(value: TRequestValues): void;
  onChangeUserType(value: EUserType): void;
}

export const RequestDemandForm: React.FC<IRequestDemandFormProps> = props => {
  const { onSubmit, onChangeUserType } = props;
  const [formValue, setFormValue] = React.useState(getFormInitialState(props));
  const handleChange = React.useCallback(
    (event: React.SyntheticEvent<HTMLInputElement>) => {
      const newFormValue = fromEventToFormField(event);

      if (event.currentTarget.name === ERequestDemandField.USER_TYPE) {
        onChangeUserType(newFormValue[ERequestDemandField.USER_TYPE].value as EUserType);
      }

      setFormValue({
        ...formValue,
        ...newFormValue,
      });
    },
    [formValue],
  );

  const handleSubmit = React.useCallback(() => {
    const formErrors = getFormErrors(formValue);

    if (formErrors) {
      return setFormValue({
        ...formValue,
        ...formErrors,
      });
    }

    onSubmit(fromFormFieldToValues(formValue));
  }, [formValue]);

  const buttonText =
    formValue[ERequestDemandField.USER_TYPE].value === EUserType.USER ? 'Отправить заявку' : 'Заполнить анкету';

  return (
    <div className={styles['form']}>
      <div className={styles['form_item']}>
        <SelectUserType
          name={ERequestDemandField.USER_TYPE}
          value={formValue[ERequestDemandField.USER_TYPE].value as EUserType}
          onChange={handleChange}
        />
      </div>
      <div className={styles['form_item']}>
        <FormFieldInput
          name={ERequestDemandField.PHONE}
          value={formValue[ERequestDemandField.PHONE].value}
          label="Ваш мобильный телефон"
          placeholder="+7"
          invalid={formValue[ERequestDemandField.PHONE].isError}
          errorMessage={formValue[ERequestDemandField.PHONE].isError ? 'Пожалуйста, введите корректный телефон' : ''}
          onChange={handleChange}
        />
      </div>
      <div className={styles['form_item']}>
        <FormFieldInput
          name={ERequestDemandField.EMAIL}
          value={formValue[ERequestDemandField.EMAIL].value}
          label="Электронная почта"
          placeholder="example@example.com"
          invalid={formValue[ERequestDemandField.EMAIL].isError}
          errorMessage={formValue[ERequestDemandField.EMAIL].isError ? 'Пожалуйста, введите корректную почту' : ''}
          onChange={handleChange}
        />
      </div>
      <div className={styles['actions']}>
        <SubmitButton onClick={handleSubmit} buttonText={buttonText} />
      </div>
      <div className={styles['agreements']}>
        <RequestDemandAgreements buttonText={buttonText} />
      </div>
    </div>
  );
};

RequestDemandForm.displayName = 'RequestDemandForm';
